import { render } from "./CalendarEventOffer.vue?vue&type=template&id=74d13afc&scoped=true"
import script from "./CalendarEventOffer.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOffer.vue?vue&type=script&lang=ts"

import "./CalendarEventOffer.vue?vue&type=style&index=0&id=74d13afc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74d13afc"

export default script